import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Amcdashboard.css";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import {
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Modal,
  Box,
  Autocomplete,
  Grid,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import ExportToExcel from "../../../Componants/Common/ExportToExcel";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import CommonButton from "../../../Componants/Common/Button";
import {
  fetchAMCList,
  fetchAmcMaster,
  fetchAMCSummary,
  updateAMC,
} from "../../../API Service/apiService";
import Loader from "../../../Componants/Common/Loader";
import Paginate from "../../../Componants/Common/Paginate";
import DashboardTabs from "../../../Componants/Common/DashboardTabs";
import CloseIcon from "@mui/icons-material/Close";
import toast, { Toaster } from "react-hot-toast";
import { Constants } from "../../../constants/Constants";
import { Calendar } from "../../../Componants/Common/Calender";
import { formatDate } from "../../../utils/dateFormatter";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(60% - 20px)",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "#EFF3FE",
  boxShadow: 24,
  border: "none !important",
  borderRadius: "10px",
  p: 4,
};

const amcOptions = [
  { label: "Basic AMC", value: "basic" },
  { label: "Premium AMC", value: "premium" },
  { label: "Gold AMC", value: "gold" },
];

const dateTypeOptions = [
  { label: "Start Date", value: "startDate" },
  { label: "End Date", value: "endDate" },
];

const Amcdashboard = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateType, setDateType] = useState("startDate");
  const [checked, setChecked] = useState(false);
  const [AMCList, setAMCList] = useState([]);
  const [searchParams, setSearchParams] = useState({
    customerId: "",
    productId: "",
    startDate: "",
    endDate: "",
    type: "",
    amcStatus: "",
    page: 1,
    limit: 10,
  });
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [AMCDropdownList, setAMCDropdownList] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedAMC, setSelectedAMC] = useState(null);
  const [AMCSummary, setAMCSummary] = useState([]);
  const [editFormData, setEditFormData] = useState({
    customerAmcId: "",
    amcId: "",
    startDate: "",
    endDate: "",
  });

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handlePageChange = async (newPage) => {
    setPage(newPage);
    const updatedParams = {
      ...searchParams,
      page: newPage,
    };
    setSearchParams(updatedParams);
    await getAMCList(updatedParams);
  };

  const handleDateTypeChange = (event) => {
    setDateType(event.target.value);
  };

  const handleStartDateChange = (fieldName, date, formattedDate) => {
    setStartDate(date);
  };

  const handleEndDateChange = (fieldName, date, formattedDate) => {
    setEndDate(date);
  };

  const handleSearch = async () => {
    const updatedParams = {
      ...searchParams,
      type: dateType,
      startDate: startDate ? startDate.toISOString().split("T")[0] : "",
      endDate: endDate ? endDate.toISOString().split("T")[0] : "",
      page: 1,
      limit: 10,
    };

    setSearchParams(updatedParams);
    await getAMCList(updatedParams);
  };

  const getAMCList = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchAMCList(params);
      console.log(response.amcs);
      if (response.status === "error") {
        setAMCList([]);
        setTotalRecords(0);
      } else {
        setAMCList(response.amcs || []);
        setTotalRecords(response.totalRecords || 0);
      }
    } catch (error) {
      console.error(error);
      setAMCList([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = async () => {
    const resetParams = {
      customerId: "",
      productId: "",
      startDate: "",
      endDate: "",
      type: "startDate",
      amcStatus: "",
      page: 1,
      limit: 10,
    };

    setStartDate(null);
    setEndDate(null);
    setDateType("startDate");
    setSearchParams(resetParams);
    await getAMCList(resetParams);
  };
  

  const getAMCSummary = async () => {
    try {
      setLoading(true);
      const response = await fetchAMCSummary();
      if (response.status == "200") {
        console.log(response.data.data);
        setAMCSummary(response.data.data);
      } else {
        console.error("Failed to fetch AMC summary:", response.message);
        setAMCSummary({
          totalAmcs: 0,
          totalAmcCustomers: 0,
          renewedThisMonth: 0,
          pendingRenewalsNextTwoMonths: 0,
        });
      }
    } catch (error) {
      console.error("Error in fetchAMCSummary:", error);
      setAMCSummary({
        totalAmcs: 0,
        totalAmcCustomers: 0,
        renewedThisMonth: 0,
        pendingRenewalsNextTwoMonths: 0,
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAMCList();
    getAMCSummary();
  }, []);

  const handleEditClick = (amc) => {
    console.log(amc);
    setSelectedAMC(amc);
    setEditFormData({
      customerAmcId: amc._id,
      amcId: amc.amcDetails._id,
      startDate: amc.startDate.split("T")[0], // Format date to YYYY-MM-DD
      endDate: amc.endDate.split("T")[0], // Format date to YYYY-MM-DD
    });
    setEditModalOpen(true);
  };

  const handleEditClose = () => {
    setEditModalOpen(false);
    setSelectedAMC(null);
    handleClearForm();
  };

  const handleEditSave = async () => {
    try {
      const response = await updateAMC(editFormData);
      if (response.status === "success") {
        toast.success(response.message);
        handleClearForm();
        handleEditClose(); // Close the modal after successful update
        getAMCList(); // Refresh the AMC list
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update AMC details");
    }
  };

  const handleClearForm = () => {
    setEditFormData({
      customerAmcId: "",
      amcId: "",
      startDate: "",
      endDate: "",
    });
    setSelectedAMC(null); // Reset the selected AMC
  };

  return (
    <>
      <div className="Amcdashboard-container">
        <HeaderNavigation value={"AMC Dashboard"} />
      </div>
      <DashboardTabs value={"amcdashboard"} />
      <div className="value-container-Amcdashboard">
        <div className="firstvaluebox-Amcdashboard">
          <p className="First-Amcdashboard">Total Customer</p>
          <h4 className="Secound-Amcdashboard">

            {AMCSummary?.totalAmcCustomers}
          </h4>
        </div>
        <div className="firstvaluebox-Amcdashboard">
          <p className="First-Amcdashboard">Total AMC</p>
          <h4 className="Secound-Amcdashboard">{AMCSummary.totalAmcs}</h4>
        </div>
        <div className="firstvaluebox-Amcdashboard">
          <p className="First-Amcdashboard">Renewal Pending in 2 months</p>
          <h4 className="Secound-Amcdashboard">
            {AMCSummary.pendingRenewalsNextTwoMonths}
          </h4>
        </div>
        <div className="firstvaluebox-Amcdashboard">
          <p className="First-Amcdashboard">MTD AMC</p>
          <h4 className="Secound-Amcdashboard">
            {AMCSummary.renewedThisMonth}
          </h4>
        </div>
      </div>
      <div className="line-Amcdashboard">
        <div className="textinput-Amcdashboard">
          <FormControl variant="standard" sx={{ minWidth: 120 }}>
            <InputLabel>Date Type</InputLabel>
            <Select
              value={dateType}
              onChange={handleDateTypeChange}
              label="Date Type"
            >
              {dateTypeOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="textinput-Amcdashboard">
          <Calendar
            value={startDate}
            handleChange={handleStartDateChange}
            fieldName="startDate"
            label="AMC Start Date"
          />
        </div>
        <div className="textinput-Amcdashboard">
          <Calendar
            value={endDate}
            handleChange={handleEndDateChange}
            fieldName="endDate"
            label="AMC End Date"
          />
        </div>
        <div className="buttons-Amcdashboard">
          <span className="buttons-Amcdashboard-span">
            <CommonButton name={"Search"} handleOnClick={handleSearch} />
          </span>
        </div>
        <span className="buttons-Amcdashboard-span">
          <CommonButton name={"Cancel"} handleOnClick={handleCancel} />
        </span>
        <div className="textinput-Amcdashboard"></div>
        <div className="textinput-Amcdashboard"></div>
      </div>

      <div className="table-Amcdashboard">
        <div className="excelexport-Amcdashboard">
          <span className="buttons-Amcdashboard-span">
            <ExportToExcel
              name="Export to Excel"
              // data={formattedAMCdashboard}
              fileName="AMCDashboard_Data"
              // headers={amcdashboardHeaders}
            />
          </span>
        </div>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Customer Name
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Product
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                Duration in month
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                noOfServices
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                costOfService
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  AMC
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Start Date
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  End Date
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Status
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {AMCList.length > 0 ? (
                AMCList.map((item) => (
                  <TableRow key={item._id}>
                    <TableCell align="center">
                      {item?.customerDetails?.customerName || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.modelDetails?.modelName || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.amcDetails?.duration || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.amcDetails?.noOfServices || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.amcDetails?.costOfService || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.amcDetails?.name || "--"}
                    </TableCell>
                    <TableCell align="center">
                      {formatDate(item?.startDate)}
                    </TableCell>
                    <TableCell align="center">
                      {formatDate(item?.endDate)}
                    </TableCell>
                    <TableCell align="center">
                      {item?.amcStatus || "--"}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton onClick={() => handleEditClick(item)}>
                        <img
                          src={editIcon}
                          alt="Edit"
                          height="20px"
                          width="20px"
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No data found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Edit Modal */}
        <Modal
          open={editModalOpen}
          onClose={handleEditClose}
          aria-labelledby="Update-AMC-Details"
        >
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <h4 style={{ margin: 0 }}>Update AMC Details</h4>
              <IconButton
                onClick={handleEditClose}
                sx={{
                  color: "#32499F",
                  "&:hover": {
                    backgroundColor: "rgba(50, 73, 159, 0.1)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Grid container spacing={3} sx={{ mt: 2 }}>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  options={AMCDropdownList}
                  value={
                    AMCDropdownList.find(
                      (item) => item._id === editFormData.amcId
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setEditFormData({
                      ...editFormData,
                      amcId: newValue ? newValue._id : "", // Ensure amcId is updated or cleared
                    });
                  }}
                  getOptionLabel={(option) => option.name || ""} // Avoid undefined errors
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select AMC"
                      variant="standard"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Start Date"
                  type="date"
                  value={editFormData.startDate}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      startDate: e.target.value,
                    })
                  }
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="End Date"
                  type="date"
                  value={editFormData.endDate}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      endDate: e.target.value,
                    })
                  }
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="flex-end"
              sx={{ mt: 4 }}
            >
              <CommonButton
                name={Constants.save}
                handleOnClick={handleEditSave}
              />
              <CommonButton
                name={Constants.cancel}
                handleOnClick={handleClearForm}
              />
            </Stack>
          </Box>
        </Modal>

        <div className="pagination-container">
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
      {loading && <Loader />}
      <Toaster />
    </>
  );
};

export default Amcdashboard;
